<template>
  <div class="news">
    <Header title="消息中心" style="background-color: #fff;"></Header>
    <Scroll ref="wrapper" :listenScroll="false" :pullUpLoad="pullUpLoadObj" @pullingUp="onPullUpLoad" :pullDownRefresh="pullDownRefreshObj" @pullingDown="onPullDownRefresh">
      <div class="paddingTop">
        <div class="news-list" v-for="(item, index) in dataList" :key="index" @click.stop="goDetails(item)">
          <div class="news-left">
            <p class="p1">{{ item.messageTitle }}</p>
            <p class="p2">{{ item.messageContent }}</p>
          </div>
        </div>
        <van-empty v-if="dataEmpty" class="custom-empty" description="暂无数据"></van-empty>
      </div>
    </Scroll>

    <div class="dialog-div">
      <van-dialog v-model="show" :title="news.messageTitle" show-cancel-button>
        <div class="div">{{news.messageContent}}</div>
        <p class="p">{{news.postName}}</p>
      </van-dialog>
    </div>

  </div>
</template>
<script>
import Header from "@/components/Header";
import transactionApi from "@/request/transactionApi";
import Scroll from "@/components/Scroll";
export default {
  name: "News",
  components: {
    Header,
    Scroll,
  },
  data() {
    return {
      hasNextPage: true,
      scrollParams: {
        pullDownRefresh: true,
        pullDownRefreshThreshold: 90,
        pullDownRefreshStop: 40,
        pullUpLoad: true,
        pullUpLoadThreshold: 0,
        pullUpLoadMoreTxt: "",
        pullUpLoadNoMoreTxt: "",
      },
      dataList: [],
      form: {
        // messageType: "", //消息类型
        status: "", // 状态
        createTime: "", // 日期
        startTimeStr: "", //开始日期
        endTimeStr: "", //结束日期
        messageStatus: "", //消息状态
        stationRecordId: "",
        messageContent: "", //消息内容
      },
      formPage: {
        pageSize: 10,
        currentPage: 1,
        totalRows: 0,
      },
      show: false,
      news: {
        messageContent: "",
        messageTitle: "",
        createTime: "",
        postName: "中油e化",
      },
    };
  },
  computed: {
    pullUpLoadObj() {
      return this.scrollParams.pullUpLoad
        ? {
            threshold: parseInt(this.scrollParams.pullUpLoadThreshold),
            txt: {
              more: this.scrollParams.pullUpLoadMoreTxt,
              noMore: this.scrollParams.pullUpLoadNoMoreTxt,
            },
          }
        : false;
    },
    pullDownRefreshObj() {
      return this.scrollParams.pullDownRefresh
        ? {
            threshold: parseInt(this.scrollParams.pullDownRefreshThreshold),
            stop: parseInt(this.scrollParams.pullDownRefreshStop),
          }
        : false;
    },
    dataEmpty() {
      return this.dataList.length == 0 && !this.loading;
    },
  },
  mounted() {
    this.getMsgList();
  },
  methods: {
    //上拉加载
    onPullUpLoad() {
      if (!this.hasNextPage) {
        this.$refs.wrapper.forceUpdate(false);
        return false;
      } else {
        setTimeout(() => {
          this.formPage.currentPage++;
          this.getMsgList();
        }, 1000);
      }
    },
    //下拉刷新
    onPullDownRefresh() {
      setTimeout(() => {
        this.formPage.currentPage = 1;
        // this.orderList = [];
        this.getMsgList();
      }, 1000);
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    getMsgList() {
      let params = Object.assign({}, this.formPage, this.form);
      delete params.totalRows;
      delete params.updateTime;
      transactionApi.messageList(params).then((res) => {
        if (res.returnCode == 0) {
          for (var i in this.formPage) {
            this.formPage[i] = res.result[i];
          }
          this.dataList = res.result.dataList;
          this.hasNextPage = res.result.hasNextPage;
          if (this.hasNextPage) {
            this.$refs.wrapper.forceUpdate(true);
          } else {
            this.$refs.wrapper.forceUpdate(false);
          }
        } else {
          this.$toast({
            type: "fail",
            message: res.result,
            duration: 1500,
          });
        }
      });
    },
    goDetails(row) {
      this.show = true;
      this.news.messageTitle = row.messageTitle;
      this.news.messageContent = row.messageContent;
      this.news.createTime = row.createTime;
      this.news.postName = "中油e化";
    },
  },
};
</script>
<style lang="stylus" scoped>
.news {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f0f1f5;

  .news-list {
    box-sizing: border-box;
    background: #fff;
    margin-bottom: 32px;
    width: 750px;
    height: 210px;
    padding: 30px 40px;

    .news-left {
      .p1 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 32px;
        color: #333333;
        margin-bottom: 24px;
      }

      .p2 {
        overflow: hidden;
        word-wrap: break-word;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 28px;
        color: #666666;
        line-height: 33px;
      }
    }
  }
}

.dialog-div {
  max-height: 400px;
  overflow: auto;

  .div {
    font-size: 28px;
    line-height: 40px;
    padding: 20px;
  }

  .p {
    font-size: 28px;
    text-align: right;
    padding: 20px;
  }
}
</style>
